// src/pages/Home.js
import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Alert, Chip, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { pinkGradient, pastels } from '../colors';

const skills = [
  { label: 'Data Science', emoji: '📊', color: pastels.pink },
  { label: 'AI', emoji: '🤖', color: pastels.lavender },
  { label: 'Cybersecurity', emoji: '🔐', color: pastels.sky }
];

function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://formspree.io/f/xpqedqqz', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'grid', gap: 1.5 }}>
      <TextField label="Name" name="name" value={form.name} onChange={handleChange} required size="small" />
      <TextField label="Your Email" name="email" type="email" value={form.email} onChange={handleChange} required size="small" />
      <TextField label="Your Message" name="message" multiline rows={3} value={form.message} onChange={handleChange} required size="small" />
      <Button variant="contained" type="submit" disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending...' : 'Send Message'}
      </Button>
      {status === 'success' && <Alert severity="success" sx={{ py: 0 }}>Message sent! I'll get back to you soon.</Alert>}
      {status === 'error' && <Alert severity="error" sx={{ py: 0 }}>Something went wrong. Please try again.</Alert>}
    </Box>
  );
}

export default function Home() {
  return (
    <>
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <Box
          sx={{
            width: 126,
            height: 126,
            borderRadius: '50%',
            overflow: 'hidden',
            mx: 'auto',
            mb: 2,
            p: '3px',
            background: pinkGradient
          }}
        >
          <Box sx={{ width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden' }}>
            <Box
              component="img"
              src="./profile.png"
              alt="Cristina Fortiz"
              sx={{
                width: '100%',
                transform: 'scale(2)',
                transformOrigin: '50% 20%'
              }}
            />
          </Box>
        </Box>
        <Typography variant="h4" component="h1">
          Cristina Fortiz ✨
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 0.75, mt: 1 }}>
          {skills.map((s) => (
            <Chip
              key={s.label}
              label={`${s.emoji} ${s.label}`}
              size="small"
              sx={{
                bgcolor: s.color,
                color: '#3a2a35',
                fontWeight: 600,
                border: 'none'
              }}
            />
          ))}
        </Box>
      </Box>

      <Box sx={{ mb: 5, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          First-generation college grad. MS in Cybersecurity, MS in Computer Science.
          A decade in federal service. Now building with data science and AI,
          trying to make my dad proud along the way. ♥
        </Typography>
        <MuiLink
          component={RouterLink}
          to="/projects"
          underline="none"
          sx={{
            display: 'inline-block',
            mt: 2.5,
            px: 2.5,
            py: 1,
            borderRadius: 999,
            fontWeight: 600,
            color: '#fff',
            background: pinkGradient,
            boxShadow: '0 4px 14px rgba(199,125,186,0.4)',
            transition: 'transform 0.2s ease',
            '&:hover': { transform: 'translateY(-2px) scale(1.03)' }
          }}
        >
          🚀 View Projects
        </MuiLink>
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          💌 Say hi
        </Typography>
        <ContactForm />
      </Box>
    </>
  );
}
